const INCOMPLETE_PUBLIC_RESEARCH =
  'Public-content research did not return a complete result for this run.';

export function localizeMerchantFacingText(
  value: string,
  language: 'en' | 'ar',
): string {
  if (language === 'ar' && value === INCOMPLETE_PUBLIC_RESEARCH) {
    return 'بحث المحتوى العام ما رجّع نتيجة كاملة في هذي المحاولة.';
  }
  return value;
}
